export interface ParseCsvResult {
    rows: string[][]
    error: string | null
}

export function parseCsv(text: string): ParseCsvResult {
    if (text.length === 0) {
        return {rows: [], error: null}
    }

    const rows: string[][] = []
    let row: string[] = []
    let field = ''
    let inQuotes = false
    let hasRecordContent = false
    let error: string | null = null

    const endField = () => {
        row.push(field)
        field = ''
    }

    const endRow = () => {
        endField()
        rows.push(row)
        row = []
        hasRecordContent = false
    }

    let i = 0
    while (i < text.length) {
        const char = text[i]

        if (inQuotes) {
            if (char === '"') {
                if (text[i + 1] === '"') {
                    field += '"'
                    i++
                } else {
                    inQuotes = false
                }
            } else {
                field += char
            }
            i++
            continue
        }

        if (char === '"' && field.length === 0) {
            inQuotes = true
            hasRecordContent = true
            i++
            continue
        }

        if (char === ',') {
            endField()
            hasRecordContent = true
            i++
            continue
        }

        if (char === '\r') {
            if (text[i + 1] === '\n') {
                i++
            }
            endRow()
            i++
            continue
        }

        if (char === '\n') {
            endRow()
            i++
            continue
        }

        field += char
        hasRecordContent = true
        i++
    }

    if (inQuotes) {
        error = `Unterminated quoted field at row ${rows.length + 1}`
    }

    if (hasRecordContent) {
        endRow()
    }

    return {rows, error}
}
